// src/ui/shell/TopBar.tsx (T1): the desktop top bar (solid white, 64px, sticky): breadcrumbs on the left,
// actions on the right. Hidden below 1024px, where the phone top bar takes over. Root class: hb-topbar.
import { Fragment, type ComponentChildren } from "preact";
import { Link } from "../../app/router";
import { cx } from "../cx";
import { Icon } from "../Icon";

export type Crumb = { label: ComponentChildren; to?: string };

export function Crumbs(props: { items: readonly Crumb[] }) {
  const last = props.items.length - 1;
  return (
    <nav class="crumbs" aria-label="Breadcrumb">
      {props.items.map((c, i) =>
        i < last ? (
          <Fragment key={i}>
            {c.to ? <Link to={c.to}>{c.label}</Link> : <span>{c.label}</span>}
            <Icon name="chev-r" />
          </Fragment>
        ) : (
          <b key={i} aria-current="page">
            {c.label}
          </b>
        ),
      )}
    </nav>
  );
}

export function TopBar(props: { crumbs?: readonly Crumb[]; left?: ComponentChildren; actions?: ComponentChildren; class?: string }) {
  return (
    <header class={cx("hb-topbar", "topbar", props.class)}>
      <div class="wrap">
        {props.crumbs ? <Crumbs items={props.crumbs} /> : null}
        {props.left}
        {props.actions ? <div class="right">{props.actions}</div> : null}
      </div>
    </header>
  );
}
